import { Country } from "@hagerty/self-service-components/api/types";

export const getCoverageUnit = (country: Country): string => {
  const unit = country === "USA" ? "miles" : "km";
  return unit;
};
